module.exports = __webpack_public_path__ + "img/Z61_13.44f1c702.jpg";